export const opacity = (
  // Two overlapping rings, the blend/opacity glyph. Scaled ~0.85 about the
  // 28×28 center: the raw paths span 1.33–26.67, wider than the ~21.5u the
  // circle family (e.g. circleInsetFill) fills, and the difference shows when
  // this sits under another icon in the same column.
  <g transform="translate(14 14) scale(0.85) translate(-14 -14)">
    <path
      d="M17.6663 10.5003C17.6663 6.54237 14.4582 3.33349 10.5003 3.33331C6.54228 3.33331 3.33333 6.54226 3.33333 10.5003C3.3335 14.4582 6.54239 17.6663 10.5003 17.6663C14.4581 17.6661 17.6662 14.4581 17.6663 10.5003ZM19.6663 10.5003C19.6662 15.5627 15.5627 19.6661 10.5003 19.6663C5.43782 19.6663 1.3335 15.5628 1.33333 10.5003C1.33333 5.43769 5.43771 1.33331 10.5003 1.33331C15.5628 1.33349 19.6663 5.4378 19.6663 10.5003Z"
      fill="currentColor"
    />
    <path
      d="M24.6663 17.5003C24.6663 13.5424 21.4582 10.3335 17.5003 10.3333C13.5423 10.3333 10.3333 13.5423 10.3333 17.5003C10.3335 21.4582 13.5424 24.6663 17.5003 24.6663C21.4581 24.6661 24.6662 21.4581 24.6663 17.5003ZM26.6663 17.5003C26.6662 22.5627 22.5627 26.6661 17.5003 26.6663C12.4378 26.6663 8.3335 22.5628 8.33333 17.5003C8.33333 12.4377 12.4377 8.33331 17.5003 8.33331C22.5628 8.33349 26.6663 12.4378 26.6663 17.5003Z"
      fill="currentColor"
    />
  </g>
);
